module.exports = __webpack_public_path__ + "static/img/aussteller_black.5e851c77.svg";